import Shimmer from './Shimmer.js';
export { default } from './Shimmer.js';
//# sourceMappingURL=index.js.map
